import { api } from '../../config/api';

import type { AuthBody, AuthResponse } from '../generated/types';

const authApi = api.injectEndpoints({
  endpoints: (build) => ({
    authentication: build.query<AuthResponse, AuthBody>({
      query: (body) => ({
        body,
        method: 'POST',
        skipTokenRefresh: true,
        url: '/v1/auth',
      }),
    }),
  }),
  overrideExisting: true,
});

export const { useAuthenticationQuery } = authApi;
